import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormPieces({
  pieceSelect,
  callback,
  title,
  button_text,
  button_variant,
  vehicles,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    state: true,
    type: '',
    order: 0,
    vehicle: [],
  });

  const handleClose = () => setShow(false);
  const handleShow = async (pieces) => {
    if (pieces) {
      const infopieces = await get('/config/piecesvehicle/' + pieces);
      if (infopieces.success) {
        const { name, state, type, order } = infopieces.data.header;
        const vehicle = infopieces.data.detail ? infopieces.data.detail : [];
        setForm({
          name,
          state,
          type,
          vehicle,
          order
        });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const handleVehicleSelect = ({ target }) => {
    const value = parseInt(target.name);
    const arrayVehicle = infoForm.vehicle;
    if (target.checked) {
      arrayVehicle.push(value);
    } else {
      const control = arrayVehicle.findIndex((element) => element === value);
      if(control>=0) arrayVehicle.splice(control,1)
    }
    setForm({ ...infoForm, vehicle: arrayVehicle });

  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm };
    if (pieceSelect) {
      respo = await put('/config/piecesvehicle/modify/' + pieceSelect, body);
      msg = 'Pieza editada Correctamente';
    } else {
      respo = await post('/config/piecesvehicle/create', body);
      msg = 'Pieza Creada Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      state: true,
      type: '',
      order: 0,
      vehicle: [],
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => {};

    initForm();
  }, []);

  const validCheckedVehicle = (id) => {
    if (infoForm.vehicle?.length > 0) {
      const valid =
        infoForm.vehicle.findIndex((element) => element === id) >= 0
          ? true
          : false;
      return valid;
    } else {
      return false;
    }
  };
  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(pieceSelect)}
      />

      <Modal animation={false}  fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
              name="name"
              value={infoForm.name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Label htmlFor="estado">Tipo</Form.Label>
            <Form.Select
              name="type"
              value={infoForm.type}
              onChange={(e) => handleForm(e)}
              aria-label="Default select example"
            >
              <option value="">Seleccione</option>
              <option value="C">Chasis</option>
              <option value="E">Carroceria Exterior</option>
            </Form.Select>

            <Form.Check
              className="mb-4"
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />
            {vehicles.map((element, i) => {
              return (
                <Form.Check
                  key={i}
                  type="switch"
                  name={element.id}
                  label={element.name}
                  checked={validCheckedVehicle(element.id)}
                  onChange={(e) => handleVehicleSelect(e)}
                />
              );
            })}

            <Form.Label htmlFor="order">Orden</Form.Label>
            <Form.Control
              name="order"
              value={infoForm.order}
              onChange={(e) => handleForm(e)}
              type="number"
            />

            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormPieces;
